import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getWeatherForecast } from '../../actions/weatherForecast'
import Forecast from '../../components/Forecast';
import './WeatherForecast.scss'


const WeatherForecast = () => {
  const dispatch = useDispatch();
  const {forecast} = useSelector((state)=>state.weatherForecast) ;
  const {locationData} = useSelector((state)=>state.locationData);
  //console.log(forecast)
  const timezone = forecast?.city?.timezone
  const forecastNew = forecast?.list;
  //console.log(forecastNew)
  const fNew = forecastNew?.map((f)=>{
    const d0 = f.dt_txt.split(' ')[0]
    const t0 = f.dt_txt.split(' ')[1]

    const dateStr = d0+'T'+t0+'Z'
    const dateLocale = new Date((new Date(dateStr).getTime())+timezone*1000).toISOString()
    const d = dateLocale.substring(0,10)
    const t = dateLocale.substring(11,19)
    return {...f,dt_txt:d,dt_txt_t:t}


  })
  const groupByDate = (arr, property) => {
    return arr?.reduce((acc, cur) => {
      acc[cur[property]] = [...acc[cur[property]] || [], cur];
      return acc;
    }, {});
}
const forecastByDate = groupByDate(fNew,'dt_txt');


  
  
  // console.log(forecastNew)
  // console.log(fNew)
 // console.log(forecastByDate)
  
useEffect(() => {
  const locData = JSON.parse(localStorage.getItem('profile1'));

  if(locData!==null){
    if(Object.keys(locData).length>0){
      dispatch(getWeatherForecast(locData['0'].lat,locData['0'].lon))
    }
  }
  
  
  
}, [locationData])


  // const getData= ()=>{
  //   dispatch(getWeatherForecast())
  // }
  return (
    <>
    
    {/* <button onClick={getData}>Click to find weatherForecast</button> */}
    <div className="forecast-main-container">
      {forecast?.list!==undefined &&(
        <>
        
          {Object.keys(forecastByDate)?.map((key,index)=>(
          
          <div key={index}>
          
         
          <Forecast  forecast={forecastByDate[key]} />
          
          
          
          </div>
          ))}
          
          
          


        
        
        </>
      )}
    </div>
    </>
  )
}

export default WeatherForecast